import { BaseApi } from './base.api.js';

export class ConsentRecordApi extends BaseApi {
    constructor(client) {
        super(client, '/consent-record');
    }
}
